// extracted by mini-css-extract-plugin
export var layoutContainer = "_4o-0";
export var layoutContainerNoRounding = "_4o-6";
export var layoutContainerOpen = "_4o-5";
export var layoutContainerResizing = "_4o-1";
export var mainContent = "_4o-2";
export var resizeDivider = "_4o-3";
export var slidePanel = "_4o-4";